<a class="link-std h100 df aic width-fit-content" (click)="onReset.emit()">
    <ng-container *ngIf="tooltip$ | async as tooltip">
        <i *ngIf="hasTooltip$ | async" class="dku-icon-arrow-undo-12 mright4" [matTooltip]="tooltip"
            matTooltipPosition="right" [matTooltipShowDelay]="300">
        </i>
        <i *ngIf="(hasTooltip$ | async) === false" class="dku-icon-arrow-undo-12 mright4"></i>
    </ng-container>
    <ng-container *ngIf="hasLabel$ | async">{{ label$ | async }}</ng-container>
</a>
